import { RootState } from 'src/store';

import { IHintListData } from './types';

export const selectHintsLoading = (state: RootState): boolean => state.hints.isLoading;
export const selectHintsLoaded = (state: RootState): boolean => state.hints.isLoaded;
export const selectHintsData = (state: RootState): IHintListData => state.hints.data;
